import { Helmet } from "react-helmet";
import { useEffect } from "react";
import AOS from 'aos';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AboutUs = () => {

    useEffect(() => {
        AOS.init({
            duration: 2000,
            once: true,
            easing : "ease-out-cubic"
        })
    }, []);

    return (
        <div className="aboutUsContainer min-h-screen flex flex-col">
            <Helmet>
                <title>Chi siamo</title>
                <meta property="og:ChiSiamo" content="Chi siamo?"></meta>
            </Helmet>
            <Navbar/>
            <main className="flex-1">
           <section className={"max-w-6xl mx-auto px-6"}>
            <p className="text-black-300 max-w-2xl mx-auto mt-16 text-center">
                Dove innovazione tecnologica e arti marziali si incontrano per creare
                un'esperienza di combattimento immersiva e spettacolare.
            </p>
           </section>
    {/* MISSION / VISION */}
    <section className="max-w-6xl mx-auto px-6 py-10 grid md:grid-cols-2 gap-10">

        <div className="bg-white p-8 rounded-xl shadow">
            <h2 className="text-2xl font-semibold mb-4">Vision</h2>
            <p className="text-gray-600">
                Trasformare il combattimento in una forma di intrattenimento immersivo,
                creando un palcoscenico dove innovazione tecnologica e onore delle arti
                marziali si incontrano.
            </p>
        </div>

        <div className="bg-white p-8 rounded-xl shadow">
            <h2 className="text-2xl font-semibold mb-4">Mission</h2>
            <p className="text-gray-600">
                Offrire una piattaforma d'élite per atleti multidisciplinari, con
                standard di sicurezza avanzati e formati di gara spettacolari per
                fan e combattenti.
            </p>
        </div>

    </section>

    {/* VALUES */}
    <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-6">

            <h2 className="text-3xl font-bold text-center mb-12">
            I NOSTRI VALORI
            </h2>

            <div className="grid md:grid-cols-4 gap-8">

                <div className="text-center">
                    <h3 className="font-semibold text-lg mb-2">Innovazione</h3>
                    <p className="text-gray-600 text-sm">
                        Nuovi formati di gara e tecnologie per rivoluzionare
                        l’esperienza dello sport da combattimento.
                    </p>
                </div>

                <div className="text-center">
                    <h3 className="font-semibold text-lg mb-2">Onore</h3>
                    <p className="text-gray-600 text-sm">
                        Rispetto per l’avversario e integrità dentro e fuori
                        l’arena.
                    </p>
                </div>

                <div className="text-center">
                    <h3 className="font-semibold text-lg mb-2">Eccellenza</h3>
                    <p className="text-gray-600 text-sm">
                        Standard atletici elevati e preparazione professionale.
                    </p>
                </div>

                <div className="text-center">
                    <h3 className="font-semibold text-lg mb-2">Trasparenza</h3>
                    <p className="text-gray-600 text-sm">
                        Protocolli medici rigorosi e comunicazione chiara con
                        atleti e fan.
                    </p>
                </div>

            </div>
        </div>
    </section>

    {/* PURPOSE */}
    <section className="bg-gray-100 py-16">
        <div className="max-w-4xl mx-auto text-center px-6">
            <h2 className="text-3xl font-bold mb-6">PERCHÈ ESISTIAMO</h2>
            <p className="text-gray-700">
                Crediamo che ogni combattimento racconti una storia di resilienza,
                disciplina e superamento dei propri limiti. ARENA esiste per
                celebrare il potenziale umano e ispirare nuove generazioni.
            </p>
        </div>
    </section>
            </main>
            <Footer/>
        </div>
    )
}
export default AboutUs